import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class EspecialidadeVeiculoService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getEspecialidadesVeiculo(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/especialidadesveiculo' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getEspecialidadesVeiculoIn(tipo,ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/especialidadesveiculoTipo/'+ tipo + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	

	getEspecialidadeVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/especialidadesveiculo/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaEspecialidadeVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/especialidadesveiculo', {
				especialidade_veiculo_nome: data.especialidade_veiculo_nome,
				especialidade_veiculo_sigla: data.especialidade_veiculo_sigla,
				status: '1'
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaEspecialidadeVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/especialidadesveiculo/' + data.especialidade_veiculo_id, {
				especialidade_veiculo_nome: data.especialidade_veiculo_nome,
				especialidade_veiculo_sigla: data.especialidade_veiculo_sigla,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaEspecialidadeVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/especialidadesveiculo/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaEspecialidadeVeiculoStatus(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/especialidadesveiculo/' + data.especialidade_veiculo_id, {
				status: data.status,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	
}
